(function () {
  var WIDGET_ID = 'running';
  var OPEN_EVENT = 'rechilero:floating-panel-open';

  function init() {
    var root = document.querySelector('[data-floating-running]');
    if (!root || root.dataset.fpInit) return;
    root.dataset.fpInit = '1';

    var toggleBtn = root.querySelector('[data-floating-running-toggle]');
    var panel = root.querySelector('[data-floating-running-panel]');
    var dismissBtn = root.querySelector('[data-floating-running-dismiss]');
    if (!toggleBtn || !panel) return;

    // Misma logica que rechilero-floating-promos.js /
    // rechilero-floating-bestsellers.js: burbuja permanente, "cerrar"
    // solo colapsa el panel. El div raiz arranca "hidden" en el Liquid
    // solo para evitar el flash-of-content antes de este script.
    root.hidden = false;

    var MOBILE_QUERY = '(max-width: 749px)';
    function isMobile() {
      return window.matchMedia(MOBILE_QUERY).matches;
    }

    // En movil hay un estado extra "pegado" (docked, ver el stylesheet
    // del .liquid) -- ver la nota larga en rechilero-floating-promos.js.
    root.dataset.state = isMobile() ? 'docked' : 'expanded';

    function openPanel() {
      root.dataset.state = 'expanded';
      panel.hidden = false;
      toggleBtn.setAttribute('aria-expanded', 'true');
      document.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: { id: WIDGET_ID } }));
    }

    function closePanel() {
      panel.hidden = true;
      toggleBtn.setAttribute('aria-expanded', 'false');
      if (isMobile()) root.dataset.state = 'docked';
    }

    toggleBtn.addEventListener('click', function () {
      if (isMobile() && root.dataset.state !== 'expanded' && panel.hidden) {
        root.dataset.state = 'expanded';
        return;
      }
      if (panel.hidden) {
        openPanel();
      } else {
        closePanel();
      }
    });

    if (dismissBtn) {
      dismissBtn.addEventListener('click', closePanel);
    }

    document.addEventListener(OPEN_EVENT, function (e) {
      if (e.detail && e.detail.id !== WIDGET_ID && !panel.hidden) closePanel();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) closePanel();
    });

    document.addEventListener('click', function (e) {
      if (root.contains(e.target)) return;
      if (!panel.hidden) {
        closePanel();
      } else if (isMobile() && root.dataset.state === 'expanded') {
        root.dataset.state = 'docked';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
